export default "__VITE_ASSET__DCb_1Ro6__";